angular.module('am4').controller('newOrganizationCtrl', function(orgFacService, $state, errorService, ngDialog, $timeout) {
    var that = this;

    that.submit = function() {
        that.isSaving = true;

        orgFacService.createOrganization(that.name)
        .then(function(org) {
            // Force reload the organizations dictionary
            orgFacService.clearOrganizationsDictionary();
            orgFacService.getOrganizationsDictionary();

            $state.go('app.am4.organization', {
                id: org.id
            });
        })
        .catch(function(e) {
            ngDialog.closeAll();

            // Need timeout to get past errors clearing on state change
            $timeout(function() {
                errorService.addError('CREATE_ORGANIZATION_ERROR', e);
            });
        })
        .finally(function() {
            that.isSaving = false;
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/newOrganizationCtrl.js